"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_CapabilityStatement_Interaction = exports.CapabilityStatement_InteractionCodeKind = void 0;
var t = __importStar(require("io-ts"));
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_Element_1 = require("./RTTI_Element");
var RTTI_markdown_1 = require("../Scalar/RTTI_markdown");
var CapabilityStatement_InteractionCodeKind;
(function (CapabilityStatement_InteractionCodeKind) {
    CapabilityStatement_InteractionCodeKind["_read"] = "read";
    CapabilityStatement_InteractionCodeKind["_vread"] = "vread";
    CapabilityStatement_InteractionCodeKind["_update"] = "update";
    CapabilityStatement_InteractionCodeKind["_patch"] = "patch";
    CapabilityStatement_InteractionCodeKind["_delete"] = "delete";
    CapabilityStatement_InteractionCodeKind["_historyInstance"] = "history-instance";
    CapabilityStatement_InteractionCodeKind["_historyType"] = "history-type";
    CapabilityStatement_InteractionCodeKind["_create"] = "create";
    CapabilityStatement_InteractionCodeKind["_searchType"] = "search-type";
})(CapabilityStatement_InteractionCodeKind = exports.CapabilityStatement_InteractionCodeKind || (exports.CapabilityStatement_InteractionCodeKind = {}));
var EnumType_1 = require("../../EnumType");
exports.RTTI_CapabilityStatement_Interaction = t.recursion('ICapabilityStatement_Interaction', function () {
    return t.partial({
        id: t.string,
        extension: t.array(RTTI_Extension_1.RTTI_Extension),
        modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
        code: (0, EnumType_1.createEnumType)(CapabilityStatement_InteractionCodeKind, 'CapabilityStatement_InteractionCodeKind'),
        _code: RTTI_Element_1.RTTI_Element,
        documentation: RTTI_markdown_1.RTTI_markdown,
        _documentation: RTTI_Element_1.RTTI_Element
    });
});
//# sourceMappingURL=RTTI_CapabilityStatement_Interaction.js.map